import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { LoadingButtonComponent } from 'app/shared/loading-button/button';
import { TranslateService } from '@ngx-translate/core';
import { FileSizePipe } from '../../shared/file-size.pipe';
import { Toast } from '../../shared/toast/toast';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';


@Component({
   selector: 'app-register-company-dialog',
   templateUrl: './register-company-dialog.component.html',
   styleUrls: ['./register-company-dialog.component.css']
})
export class RegisterCompanyDialogComponent implements OnInit {
   @ViewChild('btnSubmit') btnSubmit: LoadingButtonComponent;
   @ViewChild('upload') upload: any;
   @ViewChild('close') close: any;
   title: string;
   errorMessage = '&nbsp;';
   tel: string;
   busy = false;
   tin: any;
   companyCode = '';
   registerEtax = false;
   etaxEmail: string;
   etaxName: string;
   etaxPassword: string;
   showMailServer: boolean;
   maxFileSize = 5242880;
   server: any;
   attachments: File[] = [];
   port: any;
   isCreateByAdmin: boolean;

   periodList: any[] = [];
   sellerList: any[] = [];

   sellerCode: string;
   package: string;
   billingCode: string;

   pkgConf = new PackageConfig();
   lang: string;

   constructor(private service: IdexService, private toast: Toast, private translate: TranslateService, private fileSize: FileSizePipe,
      private dialogRef: MatDialogRef<RegisterCompanyDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private changeDetectorRefs: ChangeDetectorRef) { }

   ngOnInit() {
      this.isCreateByAdmin = this.data.isCreateByAdmin;
      this.lang = localStorage.getItem('lang') || 'en';
      this.initPeriod(this.lang);
      this.initSeller(this.lang);
   }

   submitCompany() {
      const fullName = this.service.user.name.replace(/  +/g, ' ').split(' ');
      if (this.registerEtax === true) {
         if (this.attachments.length < 1) {
            this.translate.get('alert.error_upload_cert').subscribe(s => this.toast.error(s.toString()));
            this.upload.disabled = false;
            this.close.disabled = false;
         } else {
            const data = {};
            data['email'] = this.service.user.email;
            data['firstname'] = fullName[0];
            data['lastname'] = fullName[1];
            data['tin'] = this.tin;
            data['name'] = this.etaxName.trim();
            data['username'] = this.etaxEmail.toLowerCase();
            data['taxpassword'] = this.etaxPassword;
            data['server'] = this.server;
            data['port'] = this.port;
            data['cellphone'] = this.tel;
            this.pkgConf.siteCode = this.companyCode;
            data['packageConfig'] = this.pkgConf;
            data['sellerCode'] = this.sellerCode;
            data['billingCode'] = this.billingCode;
            this.service.registerCompanyWithetax(data, this.attachments)
               .subscribe(
                  (data1) => {
                     this.translate.get('registerEtax.success').subscribe(s => this.toast.info(s));
                     this.dialogRef.close();
                  },
                  (data2) => {
                     console.error(data2);
                     this.btnSubmit.reset();
                     this.btnSubmit.disabled = false;
                  });
         }
      } else {
         const data = {};
         data['email'] = this.service.user.email;
         data['firstname'] = fullName[0];
         data['lastname'] = fullName[1];
         data['tin'] = this.companyCode ? this.companyCode : this.tin;
         data['cellphone'] = this.tel;
         data['name'] = this.etaxName.trim();
         data['isCreateByAdmin'] = this.isCreateByAdmin;
         this.pkgConf.siteCode = this.companyCode;
         data['packageConfig'] = this.pkgConf;
         data['sellerCode'] = this.sellerCode;
         data['billingCode'] = this.billingCode;
         this.service.registerCompany(data)
            .subscribe(
               (res) => {
                  if (this.isCreateByAdmin) {
                     this.translate.get('main.company-create').subscribe(s => this.toast.success(s));
                  } else {
                     this.translate.get('main.company-success').subscribe(s => this.toast.info(s));
                  }
                  this.dialogRef.close(this.isCreateByAdmin);
               },
               (data4) => {
                  console.error(data4);
                  this.btnSubmit.reset();
                  this.btnSubmit.disabled = false;
               }
            );
      }
   }
   detectMailServer(email: any) {
      if (this.etaxEmail) {
         const i = email.indexOf('@');
         const domain = i === -1 ? '' : email.substr(i + 1);
         this.showMailServer = domain.length > 0 && domain !== 'gmail.com' && domain !== 'outlook.com'
            && domain !== 'hotmail.com' && domain !== 'icloud.com' && domain !== 'yahoo.com';
      }

   }
   onChange(input: any) {
      let error = '';
      for (let i = 0; i < input.files.length; i++) {
         const file = input.files[i];
         if (file.size > this.maxFileSize) {
            if (error) {
               error += '<br/>';
            }
            this.translate.get('alert.cert_upload_exceed', { name: file.name, size: this.fileSize.transform(file.size) })
               .subscribe(s => this.toast.error(s.toString()));
            continue;
         }
         switch (file.type) {
            case 'image/jpeg':
            case 'image/jpg':
            case 'image/png':
            case 'application/pdf':
               break;
            default:
               if (error) {
                  error += '<br/>';
               }
               this.translate.get('alert.cert_upload_error', { name: file.name }).subscribe(s => this.toast.error(s.toString()));
               continue;
         }
         this.attachments.push(file);
      }
      input.value = '';
      if (error) {
         this.toast.error(error);
      }
   }
   removeFile(file: File): void {
      const i = this.attachments.indexOf(file);
      if (i !== -1) {
         this.attachments.splice(i, 1);
      }
   }
   keyPress($event: any) {
      const pattern = /[0-9\ ]/;
      const inputChar = String.fromCharCode($event.charCode);
      if ($event.keyCode !== 8 && !pattern.test(inputChar)) {
         $event.preventDefault();
      }
   }

   radioChange(event: MatRadioChange, confName: string): void {
      const value = event.value;
      this.pkgConf[confName + 'Type'] = value;
      if (value === 'INIT'){
         this.pkgConf[confName + 'Value'] = '';
      }
      this.changeDetectorRefs.detectChanges();
   }

   initPeriod(lang: string) {
      this.service.getBillingPeriod(lang).subscribe((res) => {
         if (res){
            this.periodList = res;
         }
      });
   }

   initSeller(lang: string) {
      this.service.getSeller(lang).subscribe((res) => {
         if (res){
            this.sellerList = res;
         }
      });
   }
}

export class PackageConfig {
   siteCode: string;

   siteName: string = 'site';
   siteType: string;
   siteValue: string;

   totalUserName: string = 'total_user';
   totalUserType: string;
   totalUserValue: string;

   pricePerUserName: string = 'price_per_user';
   pricePerUserType: string;
   pricePerUserValue: string

   storagePerUserName: string = 'storage_per_user';
   storagePerUserType: string;
   storagePerUserValue: string;

   storagePerSiteName: string = 'storage_per_site';
   storagePerSiteType: string;
   storagePerSiteValue: string;

   apiUsageName: string = 'api_usage';
   apiUsageType: string;
   apiUsageValue: string;

   signDocName: string = 'sign_doc';
   signDocType: string;
   signDocValue: string;

   noOfCaName: string = 'no_of_install_ca';
   noOfCaType: string;
   noOfCaValue: string;
}
